// extracted by mini-css-extract-plugin
module.exports = {"contentWrapper":"SimplePageLayout_contentWrapper__GZ4I_","header":"SimplePageLayout_header__PzDeV"};